import {
  UserApi,
  Configuration,
  type ResponseCheckResetPasswordToken,
} from '@/infrastructure/api/client_typescript';

export class PasswordResetService {
  private userApi: UserApi;

  constructor(apiBaseUrl: string) {
    const config = new Configuration({
      basePath: apiBaseUrl,
    });

    this.userApi = new UserApi(config);
  }

  async checkResetPasswordToken(
    token: string
  ): Promise<ResponseCheckResetPasswordToken> {
    const response = await this.userApi.checkResetPasswordToken({ token });
    return response.data;
  }

  async finishResetPassword(token: string, newPassword: string): Promise<void> {
    await this.userApi.finishResetPassword({
      token,
      new_password: newPassword,
    });
  }

  async resetPassword(email: string): Promise<void> {
    await this.userApi.resetPassword({ email });
  }
}
